module.exports = __webpack_public_path__ + "static/media/TVHH_3-Obs.f7a8bc8f.mp4";